<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="section">
        <strong>Mensagens</strong>
      </div>
    </div>

    <div class="ui divider"></div>

    <div class="ui grid animated fadeIn">

      <div class="sixteen wide column" style="padding-bottom: 5px !important;">
        <button class="ui icon blue button" @click="onNewMessage()">
          <i class="plus icon"></i> Nova Mensagem
        </button>
        <button class="ui icon right floated button" :class="{ loading: loadingSenders }" @click="loadSenders()">
          <i class="sync icon"></i>
        </button>        
        <div v-show="senders.length > 0" class="ui teal right floated buttons m-r-5 mobile-only">
          <div id="senders-dropdown" class="ui dropdown icon button">
            <i class="comments icon"></i>
            <div class="menu">
              <div v-for="sender in senders" class="item" @click="onSelectSender(sender)"
                :class="{ active: (selectedSender.id == sender.id) }">
                {{ sender.name }}
                <a v-if="sender.notDisplayedCount > 0" class="ui red circular tiny label">
                  {{ sender.notDisplayedCount }}
                </a>
              </div>              
            </div>
          </div>
        </div>
      </div>

      <div v-if="senders.length > 0" class="four wide column desktop-only">
        <div class="ui vertical fluid pointing menu">
          <a v-for="sender in senders" class="item" @click="onSelectSender(sender)"
             :class="{ active: (selectedSender.id == sender.id) }">
            {{ sender.name }}
            <a v-if="sender.notDisplayedCount > 0" class="ui red circular mini label">
              {{ sender.notDisplayedCount }}
            </a>            
          </a>          
        </div>
      </div>

      <div v-else class="grey text m-t-15">
        <i class="info circle icon"></i>
        <span v-if="loadingSenders">Carregando remetentes...</span>
        <span v-else>Você não possui mensagens</span>
      </div>

      <div v-if="selectedSender" class="twelve wide computer sixteen wide tablet sixteen wide mobile column">

        <div class="ui segment animated fadeIn">
          <strong>{{ selectedSender.name + ' ' + selectedSender.lastName }}</strong>
          <div class="m-t-5"><i class="users circle blue icon"></i> {{ selectedSender.group }}</div>
          <div class="m-t-5"><i class="envelope blue icon"></i> {{ selectedSender.email }}</div>
        </div>

        <div v-if="loadingMessages && selectedSender.messages.length == 0"><i class="spinner circle loading blue icon"></i> Carregando mensagens...</div>

        <div v-if="selectedSender.messages.length > 0" :key="message.id" :id="'msg-' + message.id"
              v-for="(message, index) in selectedSender.messages" class="ui segment animated fadeIn">
          <div class="ui grid">
            <div class="eight wide column">
              <div class="ui basic segment no-margin no-padding middle v-centered">
                <strong>
                  {{ message.fromUserName }}
                  <span v-if="!message.dateDisplay" class="ui teal label m-l-10" style="font-size: 10px !important;">
                    <i class="star icon"></i>Nova
                  </span>
                </strong>
              </div>
            </div>
            <div class="eight wide column">
              <div class="ui right aligned basic segment no-margin no-padding">
                <div class="grey text" style="font-size: 12px;">
                  <i class="check blue icon"></i> {{ message.when }}
                </div>
              </div>
            </div>
          </div>
          <div class="ui divider"></div>
          <strong>Assunto: </strong> {{ message.subject }}
          <div style="margin-top: 30px;" v-html="message.text"></div>
          <div class="ui divider"></div>
          <div class="ui right aligned basic segment no-margin no-padding">
            <button :id="'btn-archive-' + message.id" class="ui icon tiny basic button" 
              @click="onArchive(message.id, index)">
              <i class="trash icon"></i> Arquivar
            </button>
          </div>
        </div>

        <button v-if="selectedSender.showLoadButton" class="ui icon small button"
          :class="{ loading: loadingMessages }" @click="loadSelectedSenderMessages()">
          <i class="ellipsis horizontal icon"></i> Mais mensagens
        </button>

      </div>            

    </div>

    <message-dialog />

  </div>

</template>

<script>

  import MessageService from "@/services/message-service"
  import MessageDialog from "@/components/message-dialog"

  const MAX_REGS = 4
  const UPDATE_NOT_DISPLAYED_DELAY = 2000

  export default {
    
    data() {
      return {
        loadingSenders: true,
        loadingMessages: true,
        senders: [],
        selectedSender: null,        
      }
    },      

    components: {
      MessageDialog,
    },

    created() {

      this.loadSenders()            
    },

    mounted() {

      $("#senders-dropdown").dropdown()
    },

    methods: {

      async loadSenders() {

        this.loadingSenders = true
        
        try {          

          let response = await MessageService.getSenders()          

          this.senders = response.senders

          this.senders.forEach((sender) => sender.messages = [])
          
          if (this.senders.length > 0) {
            this.onSelectSender(this.senders[0])
          } else {
            this.selectedSender = null
          }  

          this.loadingSenders = false
          
        } catch (error) {
          
          this.loadingSenders = false
          this.$errorHandler(error)
        }
      },

      onSelectSender(sender) {        

        this.selectedSender = sender        

        if (sender.messagesLoaded)
          return

        this.loadSelectedSenderMessages()
      },

      async loadSelectedSenderMessages() {

        this.loadingMessages = true

        try {
          
          let lastId = ""
          let messages = this.selectedSender.messages          

          if (messages.length > 0)
            lastId = messages[messages.length - 1].id
          
          let response = await MessageService.find({
            fromUser: this.selectedSender.id,
            showDisplayed: true,
            setDisplayed: true,
            lastId,
            maxRegs: MAX_REGS,
          })

          response.messages.forEach((message) => {
            this.selectedSender.messages.push(message)
          })

          this.selectedSender.showLoadButton = (response.messages.length >= MAX_REGS)
          this.selectedSender.messagesLoaded = true
          this.loadingMessages = false

          this.updateSenderNotDisplayed(response.messages)
          
        } catch (error) {
          
          this.loading = false
          this.$errorHandler(error)
        }

      },

      updateSenderNotDisplayed(lastMessages) {

        let messages = lastMessages || this.selectedSender.messages

        setTimeout(() => {

          let newMessages = 0

          messages.forEach((message) => {
            if (!message.dateDisplay)
              newMessages++
          })

          if (newMessages > 0) {
            this.selectedSender.notDisplayedCount -= newMessages
            this.$store.commit("setUpdateMessages", true)
          }  

        }, UPDATE_NOT_DISPLAYED_DELAY)
      },      

      async onArchive(messageId, index) {

        $("#btn-archive-" + messageId).addClass("loading")

        try {

          await MessageService.archive(messageId)

          $("#msg-" + messageId).fadeOut(500, () => {

            this.selectedSender.messages.splice(index, 1)

            if (this.selectedSender.messages.length == 0)
              this.removeSelectedSender()            
          })           
          
        } catch (error) {
                  
          this.$errorHandler(error)
        }
      },

      removeSelectedSender() {

        let senders = []

        this.senders.forEach((sender) => {
          if (sender.id !== this.selectedSender.id)
            senders.push(this.$cloneObject(sender))
        })

        this.senders = senders.slice()

        if (this.senders.length > 0) {
          this.onSelectSender(this.senders[0])
        } else {
          this.selectedSender = null
        }  
      },

      onNewMessage() {

        $("#message-dialog").modal("show")
      },
    },
  }

</script>
